import { graphql } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { Versions as VersionsCmp } from '../../components/Versions';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';
import { useMissionReadyContext } from '../../contexts/MissionContext/hooks/useMissionReadyContext.hook';

export const MissionPage_Versions_MissionVersions_QueryDocument = graphql(`
  query MissionPage_Versions_MissionVersions_Query($originalId: Id!) {
    findAllMissionVersionsForOneOriginalId(originalId: $originalId) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id
        internalActors {
          _id
          categoryIds
          index
          isInternal
          kind
          thirdPartyId
          typeId
          ... on ActorOrganization {
            representatives {
              _id
              contextualRoleIds
              index
              personId
              typeIds
            }
            useItsEdmDomain
          }
          ... on ActorPerson {
            contextualRoleIds
          }
        }
        externalActors {
          _id
          categoryIds
          index
          isInternal
          kind
          thirdPartyId
          typeId
          ... on ActorOrganization {
            representatives {
              _id
              contextualRoleIds
              index
              personId
              typeIds
            }
            useItsEdmDomain
          }
          ... on ActorPerson {
            contextualRoleIds
          }
        }
        address {
          _id
          typeIds
          postalInfo {
            streetNumber
            route
            locality
            postalCode
            department
            region
            countryAlpha2
            building
            additional
            businessPostCode {
              postalCode
              distributorOfficeNumber
            }
            postOfficeBox
            inseeCode
          }
          locationInfo {
            coordinates
            projectionId
            altitude
            type
          }
          cadastralInfo {
            departmentCode
            municipalityCode
            oldMunicipalityCode
            districtCode
            section
            number
            sheet
          }
        }
        archiveInfo {
          _id
          endDateForAnalytics
          startDateForAnalytics
        }
        automaticMemo
        businessCreationDate
        businessCreatorId
        businessEventIds
        code
        codingConfig {
          _id
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }
        color
        createdAt
        creatorId
        description
        typeId
        internalMemo
        isConfidential
        memo
        stateId
        title
        updatedAt
        updaterId
        workflowId
        folderId
        servicesInfo {
          _id
          createdAt
          creatorId
          contentOriginId
          serviceUsagesGroups {
            _id
            groupingMode
            index
            label
            serviceUsages {
              _id
              index
              contentOriginId
              quantity {
                unitId {
                  __typename
                  mode
                  resolverId
                  value
                }
                value {
                  __typename
                  mode
                  resolverId
                  value
                }
              }
              specialService {
                title
                updatedAt
                updaterId
                value {
                  discountAmount {
                    currencyId {
                      __typename
                      mode
                      resolverId
                      value
                    }
                    value {
                      __typename
                      mode
                      resolverId
                      value
                    }
                  }
                  discountPercentage {
                    __typename
                    mode
                    resolverId
                    value
                  }
                  priceExcludingVat {
                    currencyId {
                      __typename
                      mode
                      resolverId
                      value
                    }
                    value {
                      __typename
                      mode
                      resolverId
                      value
                    }
                  }
                  vatId {
                    __typename
                    mode
                    resolverId
                    value
                  }
                }
                code
                codingConfig {
                  kind
                  strategyId
                  ... on CodingConfigManual {
                    code
                  }
                }
                content
                costUsages {
                  costId
                  index
                  quantity {
                    unitId
                    value
                  }
                }
                createdAt
                creatorId
                label
                materialUsages {
                  index
                  materialId
                  quantity {
                    unitId
                    value
                  }
                }
                statusId
              }
              serviceId
              serviceOriginId
              serviceUsageOrigin {
                missionTypeId
                serviceUsageId
              }
              settings {
                showAmountsInQuotation {
                  __typename
                  mode
                  resolverId
                  value
                }
                showCostsInQuotation {
                  __typename
                  mode
                  resolverId
                  value
                }
                showMaterialsInQuotation {
                  __typename
                  mode
                  resolverId
                  value
                }
                showQuantitiesInQuotation {
                  __typename
                  mode
                  resolverId
                  value
                }
              }
            }
          }
          updatedAt
          updaterId
        }
        reportInfos {
          stateId
          workflowId
          reportId
        }
        archiveInfo {
          startDateForAnalytics
          endDateForAnalytics
          iHavedCheckedThatReportHasBeenUploaded
          iHavedCheckedThatPlansHaveBeenUploaded
          iHavedCheckedThatQuotationHasBeenUploaded
          iHavedCheckedThatHypothesisNotesHaveBeenUploaded
          archiveBinders
        }
        quotationInfo {
          stateId
          workflowId
          header {
            paymentTermId
            paymentMethodId
            validityPeriodId
            interventionDate
            modalities
            note
          }
          quotationId
          snapshot {
            emitterId
            receiverId
            serviceUsagesGroups {
              _id
              index
              label
              groupingMode
              totalMode
              manualTotal {
                discountPercentage
                vatId
                discountAmount {
                  currencyId
                  value
                }
                priceExcludingVat {
                  currencyId
                  value
                }
              }
              automaticTotal {
                undiscountedAmountExcludingVat {
                  currencyId
                  value
                }
                discountAsAmount {
                  currencyId
                  value
                }
                discountAsPercentage
                discountedAmountExcludingVat {
                  currencyId
                  value
                }
                vatAsAmount {
                  currencyId
                  value
                }
                vatAsPercentage
                discountedAmountIncludingVat {
                  currencyId
                  value
                }
              }
              serviceUsages {
                _id
                index
                contentOriginId
                quantity {
                  unitId
                  value
                }
                specialService {
                  title
                  updatedAt
                  updaterId
                  value {
                    discountAmount {
                      currencyId
                      value
                    }
                    discountPercentage
                    priceExcludingVat {
                      currencyId
                      value
                    }
                    vatId
                  }
                  code
                  codingConfig {
                    kind
                    strategyId
                    ... on CodingConfigManual {
                      code
                    }
                  }
                  content
                  costUsages {
                    costId
                    index
                    quantity {
                      unitId
                      value
                    }
                  }
                  createdAt
                  creatorId
                  label
                  materialUsages {
                    index
                    materialId
                    quantity {
                      unitId
                      value
                    }
                  }
                  statusId
                }
                serviceId
                serviceOriginId
                serviceUsageOrigin {
                  missionTypeId
                  serviceUsageId
                }
                settings {
                  showAmountsInQuotation
                  showCostsInQuotation
                  showMaterialsInQuotation
                  showQuantitiesInQuotation
                }
              }
            }
          }
        }
        accountingInfo {
          stateId
          workflowId
          pennylaneQuoteBridge {
            userAccount
            activeId
            inactiveIds
          }
        }
      }
    }
  }
`);

export const Versions = () => {
  const { missionId } = useMissionReadyContext();

  const { data, isSuccess } = useGraphQLQuery(
    MissionPage_Versions_MissionVersions_QueryDocument,
    { originalId: missionId },
    { enabled: !!missionId },
  );

  if (isSuccess) {
    const versions = data.findAllMissionVersionsForOneOriginalId;

    if (versions.length) {
      return <VersionsCmp versions={versions} />;
    }

    return <NoData />;
  }

  return <Loading />;
};
